import { AfterViewInit, Component, Input } from '@angular/core';
import _ from 'lodash';
import { BxUnverifiedAlertService } from '../../../../core/services/bx-unverified-alert.service';
import { PermissionService } from '../../../../core/services/permission';
import { RepoRemindersService } from '../../../../data/repositories/repo-reminders.service';
import { RepoSettingsService } from '../../../../data/repositories/repo-settings.service';
import { SharedDataService } from '../../../../data/services/shared-data.service';
import { RemindersService } from '../../../dashboard/reminders.service';
import { ContactsService } from '../../contacts.service';
import { TimelineMonth } from '../../ui-components/ui-reminders-timeline/timeline-month.model';

@Component({
    selector: 'app-contact-timeline',
    templateUrl: './contact-timeline.component.html',
    standalone: false,
})
export class ContactTimelineComponent implements AfterViewInit {
    @Input() contact: any;
    months: TimelineMonth[] = [];
    moreActions = [
        {
            groupName: 'Display Only',
            actions: [
                { label: 'Show all items', condition: true, value: true },
                { label: 'Hide completed items', condition: true, value: false },
            ],
        },
    ];

    constructor(
        private remindersService: RemindersService,
        private remindersRepo: RepoRemindersService,
        private contactsService: ContactsService,
        public settings: RepoSettingsService,
        public permissionService: PermissionService,
        private sharedData: SharedDataService,
        private bxUnverifiedAlertService: BxUnverifiedAlertService
    ) {}

    ngAfterViewInit(): void {
        this.load();
    }

    load() {
        const config: any = {};

        if (this.settings.ContactsExcludeCompletedReminders) {
            config.excludeCompleted = true;
        }

        this.remindersRepo.GetByReference(this.contact.ID_Contact, config).then((data) => {
            this.months.length = 0;
            const sorted = _.sortBy(data.results, ['FirstOfMonth', 'DueDate']);
            const groups = _.groupBy(sorted, (value) => {
                return value.FirstOfMonth.toISOString();
            });
            for (const property in groups) {
                if (Object.prototype.hasOwnProperty.call(groups, property)) {
                    this.months.push({
                        month: property,
                        monthDate: new Date(property),
                        // @ts-ignore TS2322
                        items: groups[property],
                    });
                }
            }
        });
    }

    addReminder() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }
        this.contactsService
            .newReminder(this.contact)
            .then(() => {
                this.load();
            })
            .catch(() => {});
    }

    // @ts-ignore TS7006
    viewReminder(reminder) {
        this.remindersService
            .viewReminder(reminder)
            .then(() => {
                this.load();
            })
            .catch(() => {});
    }

    // @ts-ignore TS7006
    saveReminder(reminder) {
        this.remindersRepo.Save(reminder, 'Reminder saved');
    }

    resolveSettingsAction(val: boolean) {
        this.settings.ContactsExcludeCompletedReminders = !val;
        this.load();
    }
}
